import { VehicleAuditIssue, VehicleAuditIssueType } from "../logic/api";

export const countVehicleIssues = (assetVehicleIssues: VehicleAuditIssue[] | undefined) => {
    if (!assetVehicleIssues) return;

    const vehicleIssueTypes = [
        VehicleAuditIssueType.damage,
        VehicleAuditIssueType.doorsUnlocked,
        VehicleAuditIssueType.flatTyre,
        VehicleAuditIssueType.flatBattery,
        VehicleAuditIssueType.freshScratches,
        VehicleAuditIssueType.lightsOn,
        VehicleAuditIssueType.wetCar
    ];

    const vehicleIssues = assetVehicleIssues.filter(avi => vehicleIssueTypes.includes(avi.issueType));

    return vehicleIssues.length;
}